module.exports = __webpack_public_path__ + "static/media/LemonMilk.276896e2.woff";